import DMBLogo from '../assets/images/logo/LogoDMB.png'
import DMB125 from '../assets/images/thumbnails/DMB125.png'
import JASMW from '../assets/images/thumbnails/JASMW.png'
import TMDL from '../assets/images/thumbnails/TMDL.png'
import TMDLOGO from '../assets/images/logo/logotmd.jpg'
import JALogo from '../assets/images/logo/LogoJA.png'

const Next = [
  {
    id: 1,
    section: 'Next',
    title: 'LA OTRA PARTE DE Dúper Mario Bros - Episodio 12',
    thumbnailUrl: DMB125,
    webUrl: '', // Add the episode URL
    backgroundImage: DMB125,
    seriesLogo: DMBLogo,
    description: 'Proximamente la continuación que todos han estado esperando!!',
  },
  {
    id: 2,
    section: 'Next',
    title: 'Jueguemos A : Super Mario Wonder',
    thumbnailUrl: JASMW,
    webUrl: '', // Add the episode URL
    backgroundImage: JASMW,
    seriesLogo: JALogo,
    description: 'Proximamente!',
  },
  {
    id: 3,
    section: 'Next',
    title: 'TheMarioDimensionLIVE',
    thumbnailUrl: TMDL,
    webUrl: '', // Add the episode URL
    backgroundImage: TMDL,
    seriesLogo: TMDLOGO,
    description: 'Proximamente contenido de TMD y TMD2 en vivo y en directo como canal de TV!',
  },
  ];

  export default Next;